import { render } from "./dashboard.layouts.vue?vue&type=template&id=207fe392&scoped=true"
import script from "./dashboard.layouts.vue?vue&type=script&lang=js"
export * from "./dashboard.layouts.vue?vue&type=script&lang=js"

import "./dashboard.layouts.vue?vue&type=style&index=0&id=207fe392&scoped=true&lang=css"

import exportComponent from "/Users/christianreyes/Documents/Proyectos/buzon/buzon-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207fe392"]])

export default __exports__